import { useTeamTypingUsers } from "../context/TeamTypingContext";

/**
 * Escuta team_typing no socket e retorna usuários digitando no espaço informado.
 */
export function useRealtimeTeamTyping({ spaceId }) {
  const typingUsers = useTeamTypingUsers(spaceId);
  return { typingUsers };
}
